import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';

@Component({
    selector: 'tpc-vehicle-default',
    templateUrl: './vehicle-default.component.html',
    styleUrls: ['./vehicle-default.component.css']
})
export class VehicleDefaultComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    public vehicleType = '';
    private isFormSubmitted = false;
    form: FormGroup;

    constructor(protected footerService: FooterNavbarService,
                protected router: Router,
                protected fb: FormBuilder
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            if (this.form.status === 'VALID') {
                this.next();
            }
        });

        this.createForm();
    }

    checkError(param): boolean {
        return this.form.get(param).status === 'INVALID' && this.isFormSubmitted;
    }

    ngOnInit() {
    }

    private createForm(): void {
        this.form = this.fb.group({
            vehicleType: ['', Validators.required ]
        });
    }

    next() {
        this.isFormSubmitted = true;
        this.router.navigate(['/individual/vehicle/' + this.vehicleType]);
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/shared/main/vehicle/vehicle-default/vehicle-default.component.ts